// extracted by mini-css-extract-plugin
export default {"page":"App_page__Cupkj","main":"App_main__MJdxT"};